/**
 * @license Copyright (c) 2014-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// import Link from '@ckeditor/ckeditor5-link/src/link.js';
// import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';
// import MediaEmbedToolbar from '@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar.js';
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor.js";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment.js";
import AutoImage from "@ckeditor/ckeditor5-image/src/autoimage.js";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat.js";
import AutoLink from "@ckeditor/ckeditor5-link/src/autolink.js";
import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave.js";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote.js";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold.js";
import CKFinderUploadAdapter from "@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter.js";
import Code from "@ckeditor/ckeditor5-basic-styles/src/code.js";
import CodeBlock from "@ckeditor/ckeditor5-code-block/src/codeblock.js";
import DataFilter from "@ckeditor/ckeditor5-html-support/src/datafilter.js";
import DataSchema from "@ckeditor/ckeditor5-html-support/src/dataschema.js";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials.js";
import FindAndReplace from "@ckeditor/ckeditor5-find-and-replace/src/findandreplace.js";
import FontBackgroundColor from "@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js";
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor.js";
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily.js";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize.js";
import GeneralHtmlSupport from "@ckeditor/ckeditor5-html-support/src/generalhtmlsupport.js";
import Heading from "@ckeditor/ckeditor5-heading/src/heading.js";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight.js";
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline.js";
import HtmlComment from "@ckeditor/ckeditor5-html-support/src/htmlcomment.js";
import HtmlEmbed from "@ckeditor/ckeditor5-html-embed/src/htmlembed.js";
import Image from "@ckeditor/ckeditor5-image/src/image.js";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption.js";
import ImageInline from "@ckeditor/ckeditor5-image/src/imageinline.js";
import ImageInsert from "@ckeditor/ckeditor5-image/src/imageinsert.js";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize.js";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle.js";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar.js";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload.js";
import Indent from "@ckeditor/ckeditor5-indent/src/indent.js";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock.js";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic.js";
import LinkImage from "@ckeditor/ckeditor5-link/src/linkimage.js";
import List from "@ckeditor/ckeditor5-list/src/list.js";
import ListProperties from "@ckeditor/ckeditor5-list/src/listproperties.js";
import Mention from "@ckeditor/ckeditor5-mention/src/mention.js";
import PageBreak from "@ckeditor/ckeditor5-page-break/src/pagebreak.js";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph.js";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice.js";
import RemoveFormat from "@ckeditor/ckeditor5-remove-format/src/removeformat.js";
import SourceEditing from "@ckeditor/ckeditor5-source-editing/src/sourceediting.js";
import SpecialCharacters from "@ckeditor/ckeditor5-special-characters/src/specialcharacters.js";
import SpecialCharactersArrows from "@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows.js";
import SpecialCharactersCurrency from "@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency.js";
import SpecialCharactersEssentials from "@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials.js";
import SpecialCharactersLatin from "@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin.js";
import SpecialCharactersMathematical from "@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical.js";
import SpecialCharactersText from "@ckeditor/ckeditor5-special-characters/src/specialcharacterstext.js";
import StandardEditingMode from "@ckeditor/ckeditor5-restricted-editing/src/standardeditingmode.js";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough.js";
import Style from "@ckeditor/ckeditor5-style/src/style.js";
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript.js";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript.js";
import Table from "@ckeditor/ckeditor5-table/src/table.js";
import TableCaption from "@ckeditor/ckeditor5-table/src/tablecaption.js";
import TableCellProperties from "@ckeditor/ckeditor5-table/src/tablecellproperties";
import TableColumnResize from "@ckeditor/ckeditor5-table/src/tablecolumnresize.js";
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar.js";
import TextPartLanguage from "@ckeditor/ckeditor5-language/src/textpartlanguage.js";
import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation.js";
import TodoList from "@ckeditor/ckeditor5-list/src/todolist";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline.js";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount.js";
import BlockToolbar from "@ckeditor/ckeditor5-ui/src/toolbar/block/blocktoolbar";
import HeadingButtonsUI from "@ckeditor/ckeditor5-heading/src/headingbuttonsui";
import ParagraphButtonUI from "@ckeditor/ckeditor5-paragraph/src/paragraphbuttonui";
//* CUSTOM PLUGINS
import LSFullScreen from "./plugins/ls_fullscreen/index";
import LSAddImg from "./plugins/ls_addimg/index";
import LSAddBloc from "./plugins/ls_block/index";
import LSAddBlocCont from "./plugins/ls_block_cont/index";
import LSCarousel from "./plugins/ls_carousel/index";
import LSEmbed from "./plugins/ls_embed/index";
import { ShowBlocks } from "@ckeditor/ckeditor5-show-blocks";
import lSLInks from "./plugins/ls_links/index";
import LSDomElement from "./plugins/ls_dom_element/index";
import EdithCustomWidget from "./plugins/ls_custom_widget/index";
import LSBootstrapIcons from "./plugins/ls_bootstrap_icons/index";
import LSTag from "./plugins/ls_faq/index";
import LSUploadLibraryGallery from "./plugins/ls_upload-library-gallery/index";

// COMMANDE DE BUILD A FAIRE APRÈS MODIFICATION DE CE FICHIER:
// 1/ cd /inc/js/ckeditor_V5
// 2/ npm run build

// Pour ajouter un plugin, rapidement on peut déclarer une méthode ici et l'appeler dans la liste des plugins
function SpecialCharactersEmoji(editor) {
    editor.plugins.get("SpecialCharacters").addItems(
        "Emoji",
        [
            { title: "visage_0", character: "🙂" },
            { title: "visage_1", character: "😀" },
            { title: "visage_2", character: "😆" },
            { title: "visage_3", character: "🤣" },
            { title: "visage_4", character: "😅" },
            { title: "visage_5", character: "🙃" },
            { title: "visage_6", character: "😉" },
            { title: "visage_7", character: "😇" },
            { title: "visage_8", character: "🥰" },
            { title: "visage_9", character: "😍" },
            { title: "visage_10", character: "😘" },
            { title: "visage_11", character: "🤩" },
            ////////////////////////
            { title: "main_0", character: "👋" },
            { title: "main_1", character: "👌" },
            { title: "main_2", character: "👈" },
            { title: "main_3", character: "👉" },
            { title: "main_4", character: "👍" },
            { title: "main_5", character: "👎" },
            { title: "main_6", character: "🙏" },
            ////////
            { title: "coeur_0", character: "❤️" },
        ],
        { label: "Emoticons" },
    );
}

class Editor extends ClassicEditor {}

Editor.builtinPlugins = [
    // Activés :
    Alignment,
    AutoImage,
    Autoformat,
    AutoLink,
    Autosave,
    BlockQuote,
    BlockToolbar,
    Bold,
    CKFinderUploadAdapter,
    Code,
    CodeBlock,
    DataFilter,
    DataSchema,
    Essentials,
    FindAndReplace,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    HeadingButtonsUI,
    Highlight,
    HorizontalLine,
    HtmlComment,
    HtmlEmbed,
    Image,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    LinkImage,
    List,
    ListProperties,
    Mention,
    PageBreak,
    Paragraph,
    ParagraphButtonUI,
    PasteFromOffice,
    RemoveFormat,
    SourceEditing,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    StandardEditingMode,
    Strikethrough,
    Style,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextPartLanguage,
    TextTransformation,
    TodoList,
    Underline,
    WordCount,
    ImageInline,
    // Custom plugins
    LSAddBloc,
    LSAddBlocCont,
    LSCarousel,
    LSAddImg,
    LSEmbed,
    LSFullScreen,
    ShowBlocks,
    lSLInks,
    LSDomElement,
    SpecialCharactersEmoji,
    EdithCustomWidget,
    LSBootstrapIcons,
    LSTag,
    LSUploadLibraryGallery,
];

Editor.defaultConfig = {
    //////////////////////////////////////////////////////////////////
    toolbar: {
        items: [
            "fullscreen",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "outdent",
            "indent",
            "alignment",
            "|",
            "fontFamily",
            "fontSize",
            "|",
            "fontColor",
            "highlight",
            "fontBackgroundColor",
            "|",
            "link",
            "removeFormat",
            "|",
            "showBlocks",
            "-",
            "heading",
            "|",
            "style",
            "blockQuote",
            "horizontalLine",
            "insertTable",
            "specialCharacters",
            "findAndReplace",
            "undo",
            "redo",
            "|",
            "ls_dom_element",
            "ls_upload_library_gallery",
            "ls_addimg",
            {
                label: "Autres",
                withText: false,
                icon: "plus",
                items: ["ls_bloc", "ls_bloc_cont", "ls_carousel", "ls_embed", "ls_bootstrap_icons", "ls_faq"],
            },
            "|",
            {
                label: "Avancé",
                withText: true,
                icon: false,
                items: ["sourceEditing", "code", "htmlEmbed", "codeBlock", "pageBreak"],
            },
        ],

        shouldNotGroupWhenFull: true,
    },
    //////////////////////////////////////////////////////////////////
    // https://ckeditor.com/docs/ckeditor5/latest/features/editor-placeholder.html#using-the-editor-configuration
    //////////////////////////////////////////////////////////////////
    language: "fr",
    placeholder: "Votre contenu ici !",
    licenseKey: "MFN3TDdsdEVBTHJwNE04eUY5NkhDUnZPS3hrcHVEb09JQXdFRTA4L295ZUpVVmN5LU1qQXlOREF6TWprPQ",
    /////////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////

    // barre d'outils pour les images. S'affiche au survol de l'image insérée dans le contenu.
    // https://ckeditor.com/docs/ckeditor5/latest/features/images/images-styles.html#ready-to-use-styles
    image: {
        toolbar: [
            "toggleImageCaption",
            "imageTextAlternative",
            "|",
            "imageStyle:block",
            "imageStyle:inline",
            "imageStyle:side",
            "|",
            "imageStyle:alignLeft",
            "imageStyle:alignRight",
            "|",
            "imageStyle:alignBlockLeft",
            "imageStyle:alignBlockRight",
        ],
    },
    figure: {
        toolbar: ["figureStyle:block", "figureStyle:inline", "figureStyle:side"],
    },
    //////////////////////////////////////////////////////////////////
    heading: {
        options: [
            { model: "paragraph", title: "Paragraphe", class: "ck-heading_paragraph" },
            { model: "heading1", view: "h1", title: "Titre 1", class: "ck-heading_heading1" },
            { model: "heading2", view: "h2", title: "Titre 2", class: "ck-heading_heading2" },
            { model: "heading3", view: "h3", title: "Titre 3", class: "ck-heading_heading3" },
            { model: "heading4", view: "h4", title: "Titre 4", class: "ck-heading_heading4" },
            { model: "heading5", view: "h5", title: "Titre 5", class: "ck-heading_heading5" },
            { model: "heading6", view: "h6", title: "Titre 6", class: "ck-heading_heading6" },
        ],
    },
    //////////////////////////////////////////////////////////////////
    style: {
        definitions: [
            {
                name: "Bouton clair",
                element: "a",
                classes: ["bouton_clair"],
            },
            {
                name: "Bouton foncé",
                element: "a",
                classes: ["bouton_fonce"],
            },
        ],
    },
    //////////////////////////////////////////////////////////////////
    // change le comportement de l'éditeur sur les elements déclarés ici (ex: div, img, a, etc...)
    // on l'utilise par ex pour pouvoir autoriser l'ajoute de styles custom (déclarés ci-dessus) aux balises div et normalment toutes les baslises d'alements HTML
    htmlSupport: {
        allow: [
            {
                // autorise pour toutes les balises HTML l'ajout de styles, classes et attributs
                name: /.*/,
                attributes: true,
                styles: true,
                classes: true,
            },
        ],
        allowEmpty: true,
    },
    //////////////////////////////////////////////////////////////////
    fontFamily: {
        options: [
            "default", // il faudra mettre la police par défaut du site ici
            "Arial, Helvetica, sans-serif",
            "Courier New, Courier, monospace",
            "Georgia, serif",
            "Lucida Sans Unicode, Lucida Grande, sans-serif",
            "Tahoma, Geneva, sans-serif",
            "Times New Roman, Times, serif",
            "Trebuchet MS, Helvetica, sans-serif",
            "Verdana, Geneva, sans-serif",
        ],
        supportAllValues: true,
    },
    //////////////////////////////////////////////////////////////////
    fontSize: {
        options: [10, 12, 14, "default", 18, 20, 22],
        supportAllValues: true,
    },
    //////////////////////////////////////////////////////////////////
    htmlEmbed: {
        showPreviews: true,
    },
    //////////////////////////////////////////////////////////////////
    link: {
        decorators: [
            {
                mode: "manual",
                label: "Element à télécharger",
                attributes: {
                    download: "",
                },
            },
            {
                mode: "manual",
                label: "Lien sortant",
                attributes: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                },
            },
            {
                mode: "manual",
                label: "Lien interne",
                attributes: {
                    target: "_self",
                    rel: "noopener noreferrer",
                },
            },
            // ajout mailto
            {
                mode: "manual",
                label: "Lien E-mail",
                attributes: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                },
                callback: (url) => {
                    if (url.startsWith("mailto:")) {
                        return url;
                    }
                    return "mailto:" + url;
                },
            },
            // ajout tel
            {
                mode: "manual",
                label: "Lien tel (ajouter tel: avant le numéro)",
                attributes: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                },
                callback: (url) => {
                    if (url.startsWith("tel:")) {
                        return url;
                    }
                    return "tel:" + url;
                },
            },
        ],
    },
    //////////////////////////////////////////////////////////////////
    table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells", "tableCellProperties", "tableProperties"],
    },
    //////////////////////////////////////////////////////////////////
    // image: {
    // 	toolbar: [
    //         'imageStyle:inline',
    //         'imageStyle:wrapText',
    //         'imageStyle:breakText', '|',
    // 	    'toggleImageCaption',
    //         'imageTextAlternative',
    // 	]
    // },
};

export default Editor;
